import { atom } from 'jotai';

export const areHintsVisibleAtom = atom(false);
